// Static realtor + asset constants used across the reader and back-cover
export const REALTOR = {
    name: "JJ Botelho",
    tagline: "Family is my why — Helping yours is my purpose.",
    phone: "850.797.2673",
    phoneTel: "+18507972673",
    website: "www.JJ-Botelho.com",
    websiteUrl: "https://www.JJ-Botelho.com",
    emailRealty: "jjbotelho@coastalrealtyservices.com",
    emailMortgage: "JJ.Botelho@edgehomefinance.com",
    address: "111 Beal Pkwy SE, Fort Walton Beach, FL 32548",
    companyRealty: "Coastal Realty Services",
    companyMortgage: "Edge Home Finance, LLC",
    nmlsPersonal: "1880512",
    nmlsCompany: "891464",
};

export const ASSETS = {
    // JJ's family beach portrait — high-resolution original supplied by JJ.
    familyPhoto: "/assets/jj-family.jpg",
    coverHero:
        "https://images.unsplash.com/photo-1638398609922-2e48c282fe03?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85",
    welcomeImage:
        "https://images.pexels.com/photos/27890859/pexels-photo-27890859.jpeg?auto=compress&cs=tinysrgb&w=1600",
    essentialsInterior:
        "https://images.unsplash.com/photo-1600493504591-aa1849716b36?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
};
